<div class="section-header text-uppercase">
  {{ title }}
  <i
    class="pi pi-info-circle hint-icon"
    *ngIf="showTooltip && !!tooltip && !tooltip.startsWith('tooltips.')"
    [tooltipStyleClass]="tooltipStyleClass"
    [pTooltip]="tooltip"
    [tooltipPosition]="tooltipPosition"></i>
</div>
